/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import IEnergyManagementProps from '../IEnergyManagementProps';
import PortfolioEnergyWidget from './PortfolioEnergyWidget/PortfolioEnergyWidget';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import { shouldComponentNotUpdateOnDateChange } from '../../shared/Utils/Utils';
import { PollingContextProvider } from '../../../context/PollingContext/PollingContext';
import { EnergyUsageDataSourceType } from '../../shared/Enums';

const OptimusEnergyWidget = React.memo((props: IEnergyManagementProps) => {
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    emaasContext,
    isEnergyDeatils
  } = props;

  const [dataSourceType, setDataSourceType] = React.useState<
    EnergyUsageDataSourceType | string | null
  >(
    emaasContext?.enableConsumptionSourceSelect
      ? EnergyUsageDataSourceType.UTILITY_METER
      : null
  );

  return (
    <ContextProvider
      value={updateApiConfig({ connectorConfig, ...emaasContext })}
    >
      <PollingContextProvider>
        <PortfolioEnergyWidget
          connectorConfig={connectorConfig}
          requestContext={requestContext}
          bearerToken={bearerToken}
          dataSourceType={dataSourceType}
          setDataSourceType={setDataSourceType}
          optimusSubscribed={emaasContext?.optimusSubscribed}
          isEnergyDeatils={isEnergyDeatils}
        />
      </PollingContextProvider>
    </ContextProvider>
  );
}, shouldComponentNotUpdateOnDateChange);

export default OptimusEnergyWidget;
